import React from "react";
import NoUserFound from "../../assets/svg/NoAccount.svg";

const NoAccountFound = ({state,noAccountFoundCode}) => {
  // let callbackUrl = window.location.href;
  // console.log("callback URL --> ", callbackUrl)

  // let queryStr = callbackUrl.split("?")
  let baseUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;

  const handleInstallPackages = () => {
    // if (window.location.hostname.includes("txtbox")) {
    //   window.location.replace(
    //     `${process.env.REACT_APP_BASE_API_URL}/salesforce/setup`
    //   );
    // } else {
    //   window.location.replace("https://app.sms-magic.com/salesforce/setup");
    // }
    let socialProvider=state?.org_type;
    let dataCenter=state?.dataCenter;
        let action="install";
    const new_state = `org_type=${socialProvider}&source=app_exchange&dataCenter=${dataCenter}&action=${action}`;

    let url=`${baseUrl}?code=${noAccountFoundCode}&state=${encodeURIComponent(new_state)}`
    window.parent.location.href = url;
  };

  return (
    <div className="installation-container">
      <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>
      <main className="main-content">
        <div className="icon-container">
          <img
            src={NoUserFound}
            alt="No User Found"
            className="icon-sms"
            style={{ width: "61.39px", height: "69.99px" }}
          />
        </div>
        <div
          className="installation-text"
          style={{ marginBottom: "0px", marginTop: "0px" }}
        >
          <h1 className="title">No SMS Magic Account Found</h1>
          <p className="subtitle-magic">
            You don’t have an account to upgrade. Create an account and install
            SMS Magic <br /> packages to get started.
          </p>
        </div>
        <div className="error-cta">
          <button className="install-packages" onClick={handleInstallPackages}>
            <span style={{ fontSize: "14px", color: "white" }}>
              Install Packages
            </span>
          </button>
        </div>
      </main>
    </div>
  );
};

export default NoAccountFound;
